const { readDndAlwaysOn } = require('./insideChatDnd');

function smsAlertBadge(payload, alwaysOn) {
  if (!payload) return 0;
  if (alwaysOn && payload.alwaysOnCount != null) {
    return Number(payload.alwaysOnCount) || 0;
  }
  return Number(payload.count) || 0;
}

function smsAlertShowsFooter(payload, alwaysOn) {
  if (!alwaysOn) return true;
  if (!payload || payload.alwaysOnAlert == null) return true;
  return payload.alwaysOnAlert === true;
}

function unreadAlwaysOnParam(storage, role) {
  return readDndAlwaysOn(storage, role) ? '1' : '0';
}

function publishDndAlwaysOn(on) {
  if (typeof navigator === 'undefined' || !navigator.serviceWorker) return;
  const message = { type: 'pixie-dnd-always-on', on: !!on };
  const post = (worker) => {
    if (worker && typeof worker.postMessage === 'function') {
      worker.postMessage(message);
    }
  };
  try {
    post(navigator.serviceWorker.controller);
    navigator.serviceWorker.ready
      .then((reg) => post(reg && reg.active))
      .catch(() => {});
  } catch (err) {
    /* this page can still mute from the server badge */
  }
}

module.exports = {
  smsAlertBadge,
  smsAlertShowsFooter,
  unreadAlwaysOnParam,
  publishDndAlwaysOn,
};
